import { Campaign } from "config/site";
import { useWebTranslation } from "translations";
import { Icon } from "@/ui-kit";
import { Typography } from "ui-kit/Typography";
import styles from "./CampaignBadge.module.css";
import { getCampaigns } from "utils/site";

const getAppliedCampaign = (appliedCode?: string): string | undefined => {
  const campaigns = getCampaigns();

  if (!campaigns || !appliedCode) {
    return;
  }

  const value = Object.keys(campaigns).find(
    (key) => campaigns[key as Campaign] === appliedCode
  );

  return value;
};

export const CampaignBadge = ({
  fees,
}: {
  appliedCode?: string | null;
  fees?:
    | {
        discountName: string | null;
      }[]
    | null;
}) => {
  const { t } = useWebTranslation();

  const campaigns = fees?.flatMap(({ discountName }) => {
    if (!discountName) return [];

    const campaign = getAppliedCampaign(discountName);

    if (!campaign) {
      return [];
    }

    const translationKey = `discounts.${campaign}.badge`;

    const translation = t(translationKey);

    if (translationKey === translation) {
      return [];
    }

    return translation;
  });

  if (campaigns?.length === 0) {
    return null;
  }

  return (
    <Typography variant="body3" color="green300" className={styles.badge}>
      <Icon name="checkmark-badge-fill" className={styles.icon} />
      <strong>{campaigns?.join(" + ")}</strong>
    </Typography>
  );
};
